import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const INPUT_CLASS = 'h-12 bg-white border-slate-300 focus-visible:ring-indigo-500';

export default function PasswordLoginForm({ loading, onSubmit }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const submit = (e) => {
    e.preventDefault();
    onSubmit({ email, password });
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="password-login-form">
      <div className="space-y-2">
        <Label htmlFor="email" className="uppercase tracking-wide text-xs text-muted-foreground">Email</Label>
        <Input id="email" data-testid="login-email-input" type="email" placeholder="your@email.com"
          value={email} onChange={(e) => setEmail(e.target.value)} required className={INPUT_CLASS} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="password" className="uppercase tracking-wide text-xs text-muted-foreground">Password</Label>
        <Input id="password" data-testid="login-password-input" type="password" placeholder="••••••••"
          value={password} onChange={(e) => setPassword(e.target.value)} required className={INPUT_CLASS} />
      </div>
      <Button type="submit" className="w-full h-12 font-semibold transition-transform active:scale-[0.99]" disabled={loading} data-testid="login-submit-button">
        {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Logging in...</> : 'Log In'}
      </Button>
    </form>
  );
}
